import type { EasyModePlaceSelection } from "@/types/easyModePlace";
import type { FindRideSearchCriteria } from "../types/findRide.types";

export type LaterRideEndpointPayload = {
  selectedLocation: string;
  selectedCity: string;
  selectedState: string;
  selectedlocality: string;
  lat: string;
  long: string;
};

export type LaterRideRequestBody = {
  startpoint: LaterRideEndpointPayload;
  endpoint: LaterRideEndpointPayload;
  /** ISO datetime — current time + 15 minutes */
  date: string;
  /** HH:mm:ss — same moment as `date` */
  time: string;
  numberOfSeats: number;
};

function mapPlaceEndpoint(
  place: EasyModePlaceSelection
): LaterRideEndpointPayload {
  return {
    selectedLocation: place.address,
    selectedCity: place.city,
    selectedState: place.state?.trim() || "",
    selectedlocality: place.area,
    lat: String(place.lat),
    long: String(place.lng),
  };
}

function pad2(n: number): string {
  return String(n).padStart(2, "0");
}

/** Local wall-clock HH:mm:ss for a Date. */
export function formatLaterRideTime(date: Date): string {
  return `${pad2(date.getHours())}:${pad2(date.getMinutes())}:${pad2(date.getSeconds())}`;
}

/**
 * Builds POST /laterrides body from search criteria.
 * `date` / `time` use current time + 15 minutes (not the search calendar date alone).
 */
export function buildLaterRidePayload(
  criteria: FindRideSearchCriteria,
  now: Date = new Date()
): LaterRideRequestBody {
  const notifyAt = new Date(now.getTime() + 15 * 60 * 1000);

  return {
    startpoint: mapPlaceEndpoint(criteria.pickup),
    endpoint: mapPlaceEndpoint(criteria.drop),
    date: notifyAt.toISOString(),
    time: formatLaterRideTime(notifyAt),
    numberOfSeats: Math.max(1, Math.floor(criteria.seats) || 1),
  };
}
